import type { TrafficReportFeature } from '@/types/TrafficReportFeature';
import { TrafficReportType } from '@/types/TrafficReportType';

export class TrafficReport {
  static TYPES: Record<TrafficReportType, string> = {
    [TrafficReportType.ALTERNATIVE_ROUTING]: 'Alternatives Routing',
    [TrafficReportType.BARRIER]: 'Sperrung / Änderung Verkehrsführung',
    [TrafficReportType.CONSTRUCTION_WORKS]: 'Bauarbeiten',
    [TrafficReportType.DIVERSION]: 'Umleitung',
    [TrafficReportType.ENVIRONMENTAL_OBSTRUCTION]: 'Umwelt',
    [TrafficReportType.MAINTENANCE_WORKS]: 'Wartungsarbeiten',
    [TrafficReportType.NATURAL_EVENT]: 'Naturereignis',
    [TrafficReportType.PUBLIC_EVENT]: 'Veranstaltung',
    [TrafficReportType.TRAFFIC_JAM]: 'Stau',
    [TrafficReportType.UNASSIGNABLE]: 'Nicht zuordenbare Meldung',
  };

  public static title(feature: TrafficReportFeature) {
    const { type } = feature.properties;

    return TrafficReport.TYPES[type as unknown as TrafficReportType] || `Sonstiges (${type})`;
  }
}
